import { LoadingButton } from '@mui/lab';
import {
  Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography,
} from '@mui/material';
import { FC } from 'react';
import { formatRangeLabel } from 'src/pages/TruckShifts/truckShiftCopy';
import { DateRange } from 'src/pages/TruckShifts/truckShiftGrid';

type Props = {
  open: boolean;
  source: DateRange;
  target: DateRange;
  truckCount: number;
  existingCount: number;
  busy: boolean;
  onClose: () => void;
  onCopy: () => void;
};

export const CopyDialog: FC<Props> = ({
  open, source, target, truckCount, existingCount, busy, onClose, onCopy,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>先週の稼働表をコピー</DialogTitle>
    <DialogContent>
      <Typography variant="body2" sx={{ mb: 1.5 }}>先週の稼働表を、表示中の週にコピーします。</Typography>
      <Box sx={{ p: 1.5, borderRadius: 1, bgcolor: 'action.hover' }}>
        <Stack spacing={0.5}>
          <Typography variant="body2">{`コピー元: ${formatRangeLabel(source)}`}</Typography>
          <Typography variant="body2">{`コピー先: ${formatRangeLabel(target)}`}</Typography>
          <Typography variant="body2">{`対象車両: ${truckCount}台`}</Typography>
          {existingCount > 0 ? (
            <Typography variant="body2" color="warning.main">
              {`差分: 既存計画あり ${existingCount}件（上書きされます）`}
            </Typography>
          ) : (
            <Typography variant="body2" color="text.secondary">差分: 上書きする既存計画はありません</Typography>
          )}
        </Stack>
      </Box>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>キャンセル</Button>
      <LoadingButton variant="contained" loading={busy} disabled={truckCount === 0} onClick={onCopy}>
        コピーする
      </LoadingButton>
    </DialogActions>
  </Dialog>
);
